


import { Button } from "@xapp/components";
import { IntegrationType } from "generated/graphql";
import React, { FC } from "react";

export interface IntegrateConnectProps {
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;
    /**
     *
     */
    integration?: IntegrationType;
}

/**
 * @deprecated - This is for AWS Marketplaces
 * @param props
 * @returns
 */
export const IntegrateConnect: FC<IntegrateConnectProps> = props => {

    const {
        style,
        className
    } = props;

    return (
        <div style={{
            ...style, ...{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center"
            }
        }} className={className}>
            <h3>Finalize Integration</h3>
            <p>You can only link one account to one Studio application</p>
            <p>To finalize your integration:</p>
            <ol>
                <li>Click the button below and then find the organization that contains the app.</li>
                <li>Find the app and then navigate to the integrations tab.</li>
                <li>Complete the integration from the page.</li>
            </ol>
            <a href="/">
                <Button >Get Started</Button>
            </a>
        </div>
    );
}